/** Emblème « E » officiel, recadré du logo sans aucun redessin. */
export function LogoMark({ className = 'h-9 w-9' }: { className?: string }) {
  return (
    <picture>
      <source srcSet="/brand/emblem.webp" type="image/webp" />
      <img src="/brand/emblem.png" alt="" className={`${className} object-contain`} aria-hidden="true" />
    </picture>
  );
}

/**
 * Logo officiel ExpertDevis BTP. Image opaque sur fond blanc : à poser sur une surface blanche,
 * jamais recoloré ni redessiné. Le slogan officiel est déjà porté par l'image.
 */
export function Logo({ className = 'h-16 w-auto' }: { className?: string }) {
  return (
    <picture>
      <source srcSet="/brand/logo.webp" type="image/webp" />
      <img src="/brand/logo.png" alt="ExpertDevis BTP" className={className} width={640} height={277} />
    </picture>
  );
}
